/* Podstawa prawna pytania.
 *
 * W bazie pole `legal_basis` niesie dwie różne rzeczy. Przy pytaniach z aktu
 * prawnego jest sygnatura przepisu ("MPZZM prawidło 21"), ale przy 486 z 783
 * pytań siedzi tam etykieta zakresu z opracowania - "wiedza żeglarska -
 * ratownictwo". Wyświetlana z podpisem "Podstawa:" wyglądała jak niedokończona
 * treść i powtarzała nazwę działu, który i tak stoi obok.
 *
 * Zostawiamy dane w bazie (mówią, skąd wzięliśmy odpowiedź), ale pokazujemy
 * tylko wtedy, gdy naprawdę jest czym się podeprzeć.
 */
const ETYKIETA_ZAKRESU = /^\s*wiedza\s+żeglarska\b/i;

export function podstawaPrawna(pytanie) {
  const tekst = (pytanie && pytanie.legal_basis ? String(pytanie.legal_basis) : '').trim();
  if (!tekst || ETYKIETA_ZAKRESU.test(tekst)) return null;
  return tekst;
}

export default podstawaPrawna;
